import { AttackPattern, PatternState } from '../AttackPattern.js';

/**
 * Radial Ring — a Touhou-staple: an evenly-spaced ring of bullets expanding
 * outward from the boss. At phase >= 1 it fires multiple rings in quick
 * succession, each rotated slightly, so the rings spiral rather than repeat.
 *
 * `config` (damage/speed) is per-boss tuning, supplied by data/bosses.js —
 * this class has no numbers of its own baked in beyond timing/shape.
 */
export class RadialRing extends AttackPattern {
  constructor({ minPhase = 0, config }) {
    super({ name: 'Radial Ring', telegraphDuration: 0.5, activeDuration: 0.95, minPhase });
    this.config = config;
  }

  onBegin() {
    this._baseAngle = Math.random() * Math.PI * 2;
    this._ringsFired = 0;
    this._fireTimer = 0;
  }

  onActiveTick(dt, boss, player, pool) {
    this._fireTimer -= dt;
    const maxRings = boss.phase >= 1 ? 3 : 1;
    if (this._fireTimer <= 0 && this._ringsFired < maxRings) {
      this._fireRing(boss, pool, this._ringsFired);
      this._ringsFired++;
      this._fireTimer = 0.28;
    }
  }

  _fireRing(boss, pool, index) {
    const count = 16 + boss.phase * 4;
    const rotOffset = index * 0.18;
    const { damage, speed } = this.config;
    for (let i = 0; i < count; i++) {
      const angle = this._baseAngle + rotOffset + (i / count) * Math.PI * 2;
      pool.fire({
        x: boss.x,
        y: boss.y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        radius: 2.5,
        damage,
        color: '#ff5d6c',
        lifetime: 4,
      });
    }
  }

  getVisual(boss) {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return { kind: 'ringPulse', x: boss.x, y: boss.y, t: 1 - this._timer / this.telegraphDuration };
  }
}
